import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FindPasswordPage.module.css';
import FindPasswordInputPanel from './panel/findpw/FindPasswordInputPanel';
import FindPasswordEmailVerificationPanel from './panel/findpw/FindPasswordEmailVerificationPanel';
import PasswordResetPanel from './panel/findpw/PasswordResetPanel';
import FindPasswordSuccessPanel from './panel/findpw/FindPasswordSuccessPanel';
// import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';
import { IAM_PATH } from '../../utils/Config';
import axios from "../../utils/api/axios";
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';

function FindPasswordPage() {
  const navigate = useNavigate();
  const { showDialog } = useDialog();
  const [step, setStep] = useState(1);
  const [userData, setUserData] = useState({
    fullEmail: '',
    newPassword: '',
  });

  const handleEmailInput = (fullEmail) => {
    setUserData({
      ...userData,
      fullEmail,
    });
    setStep(2);
  };

  const handleEmailVerification = (isVerified) => {
    setUserData({
      ...userData,
      isEmailVerified: isVerified,
    });
    setStep(3);
  };

  const handlePasswordReset = async (newPassword) => {
    setUserData({ ...userData, newPassword });
    

    const requestData = {
      "unifiedProfileId": userData.fullEmail,
      "password": newPassword,
    };

    const existRes = await axios.post(`${IAM_PATH}/update/password`, requestData);

    if(existRes.data.code === 200){
      setStep(4);
    } else if(existRes.data.code === 200){
      showDialog({
          iconType: "warning",
          type: 'error',
          title: "오류",
          message: "기존 비밀번호랑 동일한 비밀번호 입니다.",
      });
      // showDialog(DialogEnum.FAIL, "변경 실패", "기존 비밀번호랑 동일한 비밀번호 입니다.");
    }else{
      showDialog({
          iconType: "warning",
          type: 'error',
          title: "오류",
          message: "비밀번호 변경 오류",
      });
      // showDialog(DialogEnum.FAIL, "오류", "비밀번호 변경 오류");
      navigate('/login');
    }
  };

  const handleComplete = () => {
    navigate('/login');
  };

  const goBack = () => {
    if (step === 1) {
      navigate('/login');
    } else {
      setStep(step - 1);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <FindPasswordInputPanel onNext={handleEmailInput} />;
      case 2:
        return <FindPasswordEmailVerificationPanel onNext={handleEmailVerification} fullEmail={userData.fullEmail} />;
      case 3:
        return <PasswordResetPanel onNext={handlePasswordReset} />;
      case 4:
        return <FindPasswordSuccessPanel onNext={handleComplete} />;
      default:
        return null;
    }
  };

  return (
    <div className="innocode-breakpoint-layout-bg">
      <div className="innocode-breakpoint-content">
        <div className={styles.layout_container}> 
          <header className={styles.header}>
              <InnocodeButton enablePadding={false} onClick={() => { navigate(-1); }} designType={'assistive'} theme={'opacity'} iconOnly={true} icon={
                  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
                  </svg>

              }></InnocodeButton>
          </header>
          <div className={styles.content_wrapper}>{renderStep()}</div>
          <>
          </>
        </div>
      </div>
    </div>
  );
}

export default FindPasswordPage;
